import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { InputCustomEvent, IonInput, IonItem } from '@ionic/angular/standalone';

import { AsYouType, CountryCode } from 'libphonenumber-js/min';

@Component({
    selector: 'lib-phone-number-input',
    standalone: true,
    imports: [IonItem, CommonModule, ReactiveFormsModule, IonInput],
    templateUrl: './phone-number-input.component.html',
    styleUrl: './phone-number-input.component.css'
})
export class PhoneNumberInputComponent {
    /* eslint-disable */
    @Input() label: string = 'Phone number';
    @Input() autocomplete: string = 'tel tel-national';
    @Input() placeholder: string | undefined = undefined;
    @Input() isInvalidBorderDisplay: boolean = false;
    @Input() required: boolean = false;
    @Input() initialValue: string | undefined = undefined;
    @Input() ionItemWrap: boolean = true;
    @Input() countryFormat: CountryCode = 'US';

    @Input() disabled: boolean = false;
    @Input() inputClasses: string = '';
    @Input() labelPlacement: 'end' | 'fixed' | 'floating' | 'stacked' | 'start' = 'stacked';
    @Input() helperText: string | undefined = undefined;
    @Input() errorText: string | undefined = undefined;

    @Input() form: FormGroup = new FormGroup({
        input: new FormControl('')
    });
    @Input() controlName: string | undefined = 'input';

    formattedNumber: string | null | undefined = '';
    inputtedNumber: string | null | undefined = '';

    @Output() selectedFormattedNumber = new EventEmitter<string | null | undefined>();
    @Output() selectedInputtedNumber = new EventEmitter<string | null | undefined>();

    @ViewChild('phoneInput') input!: IonInput;

    ngOnInit() {
        if (this.initialValue) {
            const asYouType = new AsYouType(this.countryFormat);
            this.formattedNumber = this.initialValue ? asYouType.input(this.initialValue) : null;
        }

        if (this.initialValue && this.controlName) {
            this.form.get(this.controlName)?.patchValue(this.initialValue);
            if (this.disabled) {
                this.form.get(this.controlName)?.disable();
            }
        }

        if (this.disabled && !this.controlName) {
            this.form.disable();
        }
    }

    formatNum(event: InputCustomEvent) {
        let value = event.detail.value || '';
        const asYouType = new AsYouType(this.countryFormat);
        this.formattedNumber = asYouType.input(value);
        this.inputtedNumber = asYouType.getNumber()?.nationalNumber || null;

        this.selectedFormattedNumber.emit(this.formattedNumber);
        this.selectedInputtedNumber.emit(this.inputtedNumber);
        this.setValue(this.inputtedNumber || '');
    }

    setValue(value: string) {
        if (this.controlName) {
            this.form.get(this.controlName)?.patchValue(value);
        }
    }

    markAsTouched() {
        console.log('mark as touched');
        this.form.markAllAsTouched();
    }
}
